window._ = require('lodash');
import Popper from 'popper.js/dist/umd/popper.js';
import Anime from 'animejs/lib/anime.es';
window.anime = Anime;

window.$ = window.jQuery = require('jquery');
window.Popper = Popper;
require('bootstrap');
require('pc-bootstrap4-datetimepicker'); // bootstrap datetime4
window.feather = require('feather-icons'); // feathericon.com
window.moment = require('moment');
moment.locale('ko');

import Dropzone from 'dropzone';
window.Dropzone = Dropzone;
window.nestable = require('nestable2'); // nestable
window.tinymce = require('tinymce'); // tinymce
window.ClipboardJs = require('clipboard'); // clipboard
window.Sortable = require('sortablejs');
window.Plyr = require('plyr'); // html5 player
import 'plyr/dist/plyr.polyfilled';
window.slick = require('slick-carousel');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found.');
}

const apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
    window.axios.defaults.headers.common.Authorization = `Bearer ${apiToken.content}`;
}

import WebFont from 'webfontloader';

WebFont.load({
    custom: {
        families: ['SUIT Variable'],
        urls: ['https://cdn.jsdelivr.net/gh/sun-typeface/SUIT@2/fonts/variable/woff2/SUIT-Variable.css']
    }
});

$.extend(true, $.fn.datetimepicker.defaults, {
    dayViewHeaderFormat: 'YYYY MM',
    locale: 'en',
    timeZone: 'America/Los_Angeles',
    icons: {
        time: 'datetime-icon datetime-icon-clock',
        date: 'datetime-icon datetime-icon-calendar',
        up: 'datetime-icon datetime-icon-arrow-up',
        down: 'datetime-icon datetime-icon-arrow-down',
        previous: 'datetime-icon datetime-icon-chevron-left',
        next: 'datetime-icon datetime-icon-chevron-right',
        today: 'datetime-icon datetime-icon-check',
        clear: 'datetime-icon datetime-icon-trash',
        close: 'datetime-icon datetime-icon-circle'
    }
});

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

window.setCookie = (cookieName, cookieValue, cookieExpire, cookiePath, cookieDomain, cookieSecure) => {
    let cookieText=escape(cookieName)+'='+escape(cookieValue);
    cookieText+=(cookieExpire ? '; EXPIRES='+cookieExpire.toGMTString() : '');
    cookieText+=(cookiePath ? '; PATH='+cookiePath : '');
    cookieText+=(cookieDomain ? '; DOMAIN='+cookieDomain : '');
    cookieText+=(cookieSecure ? '; SECURE' : '');
    document.cookie=cookieText;
};

window.getCookie = (cookieName) => {
    let cookieValue=null;
    if(document.cookie){
        let array=document.cookie.split((escape(cookieName)+'='));
        if(array.length >= 2){
            let arraySub=array[1].split(';');
            cookieValue=unescape(arraySub[0]);
        }
    }
    return cookieValue;
};

window.deleteCookie = (cookieName)=>{
    let temp=getCookie(cookieName);
    if(temp){
        setCookie(cookieName,temp,(new Date(1)));
    }
};

window.numberWithComma = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
